import { useContext } from 'react';

import { FactsheetOverlayContainerContext } from './FactsheetOverlayContainerContextBase';

export const useFactsheetOverlayContainer = () => useContext(FactsheetOverlayContainerContext);
